import { CoachingSessionStatus } from './coaching.enum';

export const currentSessionStatuses = [CoachingSessionStatus.Confirmed];
export const completedSessionStatuses = [CoachingSessionStatus.Completed];